/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetLoanQueryResponse, GetLoanPathParams, GetLoan400, GetLoan401, GetLoan403, GetLoan404, GetLoan409, GetLoan500 } from "../../types/financialHubController/GetLoan.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getLoan } from "../../client/financialHubController/getLoan.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getLoanQueryKey = (organizationId: GetLoanPathParams["organizationId"] | undefined, loanId: GetLoanPathParams["loanId"] | undefined) => [{ url: '/api/organizations/:organizationId/financial/loans/:loanId', params: {organizationId:organizationId,loanId:loanId} }] as const

export type GetLoanQueryKey = ReturnType<typeof getLoanQueryKey>

export function getLoanQueryOptions(organizationId: GetLoanPathParams["organizationId"] | undefined, loanId: GetLoanPathParams["loanId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getLoanQueryKey(organizationId, loanId)
        return queryOptions<GetLoanQueryResponse, ResponseErrorConfig<GetLoan400 | GetLoan401 | GetLoan403 | GetLoan404 | GetLoan409 | GetLoan500>, GetLoanQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && loanId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getLoan(organizationId!, loanId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get a loan with its full installment schedule
 * {@link /api/organizations/:organizationId/financial/loans/:loanId}
 */
export function useGetLoan<TData = GetLoanQueryResponse, TQueryData = GetLoanQueryResponse, TQueryKey extends QueryKey = GetLoanQueryKey>(organizationId: GetLoanPathParams["organizationId"] | undefined, loanId: GetLoanPathParams["loanId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetLoanQueryResponse, ResponseErrorConfig<GetLoan400 | GetLoan401 | GetLoan403 | GetLoan404 | GetLoan409 | GetLoan500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getLoanQueryKey(organizationId, loanId)
         

         const query = useQuery({
          ...getLoanQueryOptions(organizationId, loanId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetLoan400 | GetLoan401 | GetLoan403 | GetLoan404 | GetLoan409 | GetLoan500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}